module.exports = __webpack_public_path__ + "img/detailspagechart.bbbe96eb.svg";